import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CompareFiles } from './components/CompareFiles';

const comparefiles = (props,{ t }) => (
  <Container  >
    <CompareFiles  {...props} />
  </Container>
);

comparefiles.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(comparefiles);
